import React from 'react'

function SpaceBlock() {
  return (
    <div style={{marginTop:"20%"}} className='space-block'></div>
  )
}

export default SpaceBlock